/**
 * Support Tickets Service Module
 *
 * Manages customer support tickets.
 */

import { api } from './client';
import type {
  Ticket,
  TicketReply,
  TicketCreateRequest,
  TicketReplyRequest,
  ListResponse,
  PaginationParams,
} from './types';

/**
 * Tickets API
 *
 * Endpoints for support ticket management.
 */
export const ticketsAPI = {
  /**
   * Get tickets
   *
   * Retrieves list of user's support tickets.
   *
   * **Endpoint:** GET /api/tickets/
   * **Protected:** Yes
   */
  getTickets: async (params?: PaginationParams): Promise<ListResponse<Ticket>> =>
    api.get<ListResponse<Ticket>>('/api/tickets', params),

  /**
   * Create ticket
   *
   * Creates a new support ticket.
   *
   * **Endpoint:** POST /api/tickets/
   * **Protected:** Yes
   */
  create: async (request: TicketCreateRequest): Promise<Ticket> =>
    api.post<Ticket>('/api/tickets', request),

  /**
   * Get ticket details
   *
   * Retrieves details for a specific ticket.
   *
   * **Endpoint:** GET /api/tickets/{id}
   * **Protected:** Yes
   */
  getById: async (id: number): Promise<Ticket> =>
    api.get<Ticket>(`/api/tickets/${id}`),

  /**
   * Reply to ticket
   *
   * Adds a reply to a support ticket.
   *
   * **Endpoint:** POST /api/tickets/{id}/reply
   * **Protected:** Yes
   */
  reply: async (id: number, request: TicketReplyRequest): Promise<TicketReply> =>
    api.post<TicketReply>(`/api/tickets/${id}/reply`, request),
};
